<template>
    <div class="container px-2">
        <ul class="d-flex flex-md-row flex-column align-items-center justify-content-center gap-3 ps-0 mb-0">
            <li class="d-block">
                <router-link :to="{name: 'parts', params: {locale: currentLocale}}" class="nav-link">
                    {{ trans('auto_parts') }}
                </router-link>
            </li>

            <li class="d-block">
                <router-link :to="{name: 'sale', params: {locale: currentLocale}}" class="nav-link text-danger">
                    {{ trans('sale') }}
                </router-link>
            </li>

            <li class="d-block">
                <router-link :to="{name: 'news', params: {locale: currentLocale}}" class="nav-link">
                    {{ trans('news') }}
                </router-link>
            </li>

            <li class="d-block">
                <router-link :to="{name: 'about-us', params: {locale: currentLocale}}" class="nav-link">
                    {{ trans('about_us') }}
                </router-link>
            </li>

            <li class="d-block">

                <router-link :to="{name: 'contacts', params: {locale: currentLocale}}" class="nav-link">
                    {{ trans('contacts') }}
                </router-link>
            </li>
        </ul>

        <p class="text-center fs-14 mt-3 mb-0">
            &copy; {{ trans('ltd_get_parts') }} 2023
        </p>
    </div>
</template>

<script>
import {t} from "@/lang/core/helpers";
import { mapGetters } from "vuex";

export default {
    name: 'FooterGP',

    computed: {
        ...mapGetters([
            'menuCompanyDefaultLocale',
        ]),

        currentLocale() {
            return window.localStorage.getItem('locale') 
                || this.menuCompanyDefaultLocale 
                || 'ka'
        }
    },

    methods: {
        trans(key) {
            return t(key)
        },
    }
}
</script>

<style scoped>
footer .nav-link {
    transition: .3s;
}

footer .nav-link:hover {
    color: #ffc107;
}
</style>